<template>
    <div class="type mt-4 position-relative">
    <ldc-select
        v-model="type"
        placeholder="Chọn loại tin"
        class="rv-select-form" v-if="$detect == 'web'">
        <ldc-option
            :value="0"
            label="Cần bán"/>
        <ldc-option
            :value="1"
            label="Cần mua"/>
    </ldc-select>
    <ldc-select-mobile
        :showPlaceholder="false"
        placeholder="Chọn loại tin"
        title="Loại tin"
        v-model="type"
        class="select-mobile-post"
        v-else>
        <ldc-option-mobile
            :value="0"
            label="Cần bán"/>
        <ldc-option-mobile
            :value="1"
            label="Cần mua"/>
    </ldc-select-mobile>
    <div class="text-position-select position-absolute text-primary">Loại tin</div>
</div>
</template>
<script>
export default {
    props: ['data'],
    data() {
        return {
            type: ''
        }
    },
    watch: {
        data(val){
            this.type = val*1;
        },
        type(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        this.type = this.data*1;
    }
}
</script>
<style lang="scss">
.rv-create {
    .body {
        .rv-select-form {
            .ldc-input {
                border: 1px solid rgba(0, 0, 0, 0.2) !important;
                color: #000;
                font-size: 16px !important;
                height: unset !important;
                line-height: unset !important;
                padding: 10px !important;
                border: 1px solid #007bff !important;
            }
        }
        .select-mobile-post {
            border: 1px solid #007bff;
            border-radius: 4px;
            .ldc-placeholder-select-mobile {
                border-radius: 4px;
                i {
                    float: right;
                }
            }
        }
        .text-position-select {
            top: -13px;
            padding: 0 10px;
            background: #fff;
            margin-left: 10px;
        }
    }
}
</style>
